export default {"src":"/_next/static/media/post.e3ab5d00.svg","height":284,"width":284};